import React, { useState } from 'react';
import css from './ListingStatistics.css';
import { IconSpinner } from '..';
import { ensureListing } from '../../util/data';
import { useImpressionsRequest } from './useImpressionsRequest';

const ListingStatistics = ({ currentListing }) => {
    const [impressions, setImpressions] = useState(null);
    const {
        id,
        attributes: {
            publicData: { viewsNum_total: viewsNum, favoredBy = [] },
        },
    } = currentListing;

    const favoriteNum = favoredBy.length;

    const { uuid: listingId } = id || {};
    const { loading } = useImpressionsRequest({ listingId, setImpressions });

    return (
        <div className={css.statistics}>
            {loading ? (
                <IconSpinner />
            ) : (
                <div>
                    <p className={css.subTitle}>Impressionen</p>
                    {impressions || 0}
                </div>
            )}
            <div>
                <p className={css.subTitle}>Ansichten</p>
                {viewsNum || 0}
            </div>
            <div>
                <p className={css.subTitle}>Favorisiert</p>
                {favoriteNum}
            </div>
        </div>
    );
};

export default ListingStatistics;
